import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageTakeoffJCBCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Takeoff JCB Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/japan-takeoff-jcb-card.png',
  show: true,
  position: 'right'
};

export const BannerContentTakeoffJCBCardMocks: GenericLabel = {
  title: 'Delta SkyMiles Takeoff JCB Card',
  subtitle: ''
};

export const BannerTakeoffJCBCardMocks: CardCarouselBanner = {
  labels: BannerContentTakeoffJCBCardMocks,
  image: BannerImageTakeoffJCBCardMocks
};
